import * as ActionTypes from "constants-lib/actionTypes"

export const setDashboardServices = (data) => ({
  type: ActionTypes.SET_DASHBOARD_SERVICES,
  payload: data,
})
